import React, { useState } from 'react';
import { ShieldAlert, Flag } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/utils/api';
import { Button } from '@/components/ui/button';

const REASONS = [
  { value: 'payment', label: 'Pediram-me dinheiro' },
  { value: 'telegram', label: 'Contactaram-me por Telegram / WhatsApp' },
  { value: 'fake', label: 'A vaga parece falsa' },
  { value: 'other', label: 'Outro motivo' },
];

export const JobSafetyNotice = ({ jobId }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('payment');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/jobs/${jobId}/report`, { reason, message: message.trim() || null, contact_email: email.trim() || null });
      setSent(true); setOpen(false); toast.success('Denúncia enviada. Obrigado — a equipa Trabadju vai verificar.');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Não foi possível enviar.'); } finally { setBusy(false); }
  };
  return (
    <section className="mt-8 rounded-xl border border-amber-300 bg-amber-50 p-4" data-testid="job-safety-notice">
      <div className="flex items-start gap-3">
        <ShieldAlert className="h-5 w-5 flex-none text-amber-700 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-amber-900 font-medium">O Trabadju nunca pede pagamentos. Se uma empresa lhe pedir dinheiro ou o contactar por Telegram, denuncie.</p>
          {sent ? <p className="mt-2 text-sm text-emerald-700 font-semibold" data-testid="job-report-sent">Denúncia enviada. Obrigado!</p> : (
            <Button variant="outline" size="sm" className="mt-2 border-amber-400 text-amber-900" onClick={() => setOpen(!open)} data-testid="job-report-btn"><Flag className="h-3.5 w-3.5 mr-1" />Denunciar vaga</Button>
          )}
          {open && (
            <div className="mt-3 space-y-2" data-testid="job-report-form">
              <select value={reason} onChange={(e) => setReason(e.target.value)} className="w-full h-10 rounded-md border border-amber-300 bg-white px-2 text-sm" data-testid="job-report-reason">
                {REASONS.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
              </select>
              <textarea value={message} onChange={(e) => setMessage(e.target.value)} maxLength={1000} rows={3} placeholder="O que aconteceu? (opcional)" className="w-full rounded-md border border-amber-300 bg-white p-2 text-sm" data-testid="job-report-message" />
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} maxLength={200} placeholder="O seu email para o contactarmos (opcional)" className="w-full h-10 rounded-md border border-amber-300 bg-white px-2 text-sm" data-testid="job-report-email" />
              <Button size="sm" onClick={send} disabled={busy} className="bg-amber-600 hover:bg-amber-700" data-testid="job-report-submit">Enviar denúncia</Button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
